import { render, staticRenderFns } from "./UserActivation.vue?vue&type=template&id=0ac30ce0&scoped=true&"
import script from "./UserActivation.vue?vue&type=script&lang=js&"
export * from "./UserActivation.vue?vue&type=script&lang=js&"
import style0 from "./UserActivation.vue?vue&type=style&index=0&id=0ac30ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac30ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer,VRow})
